/** Strings owned by the Charts page (charts/). */
export const CHARTS_STRINGS = {
    'charts.title': { en: 'Charts', ru: 'Графики' },
    'charts.ops_status_title': { en: 'Operations by status', ru: 'Операции по статусам' },
    'charts.ops_status_hint_day': { en: 'Operations per day', ru: 'Операций в день' },
    'charts.ops_status_hint_hour': { en: 'Operations per hour', ru: 'Операций в час' },
    'charts.status_sent': { en: 'Sent', ru: 'Отправлено' },
    'charts.status_success': { en: 'Success', ru: 'Успех' },
    'charts.status_cancel': { en: 'Cancel', ru: 'Отмена' },
    'charts.status_decline': { en: 'Decline', ru: 'Отклонено' },
    'charts.status_in_work': { en: 'In work', ru: 'В работе' },
    'charts.total': { en: 'Total', ru: 'Всего' },
    'charts.empty': { en: 'No operations in this range.', ru: 'За этот период операций нет.' },
    'charts.range_too_long': { en: 'Pick a range of at most 92 days.', ru: 'Выберите период не длиннее 92 дней.' },
    'charts.hourly_too_long': { en: 'An hourly breakdown covers at most 31 days — narrow the range or break it down by day.', ru: 'Разбивка по часам — не больше 31 дня: сузьте период или выберите разбивку по дням.' },
    'charts.bucket': { en: 'Breakdown', ru: 'Разбивка' },
    'charts.bucket_auto': { en: 'Auto', ru: 'Авто' },
    'charts.bucket_hour': { en: 'By hour', ru: 'По часам' },
    'charts.bucket_day': { en: 'By day', ru: 'По дням' },
    'charts.legend_toggle': { en: 'Click to show or hide a status', ru: 'Нажмите, чтобы показать или скрыть статус' },
    'charts.view_chart': { en: 'Chart', ru: 'График' },
    'charts.view_table': { en: 'Table', ru: 'Таблица' },
    'charts.col_period': { en: 'Period', ru: 'Период' },
};
